// The persistence shapes. The Store owns them; the engine reads and writes them inside one
// transaction per unit of work.

export interface AggregateRecord {
  type: string;
  id: string;
  schemaVersion: number;
  // Highest server aggregate_version folded into state; the read cursor.
  serverVersion: number;
  lastSentClientSeq: number;
  // Highest client_seq ever stamped, sent or not. Allocated inside the commit transaction.
  nextClientSeq: number;
  // Highest li this aggregate has allocated. li is per aggregate, allocated from here inside the
  // unit of work, so the log's primary key [type, id, li] needs no autoincrement and no index.
  lastLi: number;
  // Highest li folded when this record was written. The state document is the fold of every row
  // with li <= appliedLi; rows the fold left unchanged advance appliedLi without a state write.
  appliedLi: number;
  // The lowest si still held after a local trim; 1 when nothing has been trimmed.
  trimFloor: number;
  createdAt: number;
  modifiedAt: number;
}

// One row of the log. `li` is the per-aggregate insertion number and the fold order. `si` is the
// server's aggregate_version once the server holds the event and 0 until then, so "unsent" is
// the query si === 0. `serverTs` is the batch's server_timestamp at receipt, 0 for own events.
export interface StoredEvent {
  li: number;
  type: string;
  id: string;
  si: number;
  clientSeq: number;
  clientId: string;
  userId: string | undefined;
  ts: number;
  serverTs: number;
  typeMajor: number;
  typeMinor: number;
  // Plaintext JSON {kind, payload}. Encryption is a wire concern.
  value: string;
}

export type NewEvent = Omit<StoredEvent, 'li'>;

export interface StateRecord {
  type: string;
  id: string;
  schemaVersion: number;
  appliedLi: number;
  state: unknown;
}

// Online-mode request dedup: event_id to the version its write produced.
export interface DedupRecord {
  type: string;
  id: string;
  eventId: string;
  version: number;
  expiresAt: number;
}

export interface MetadataRecord {
  key: string;
  value: unknown;
}

export const META_CLIENT_ID = 'clientId';
